module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_1-470a367d8c6abb32ed3bd04a16a74f6d.jpg";